import type { NftWithCollection } from '../lib/playproject';
import { create } from 'zustand';

/** TTL for optimistic NFTs in milliseconds (5 minutes) */
const OPTIMISTIC_NFT_TTL_MS = 5 * 60 * 1000;

interface TimestampedNft extends NftWithCollection {
  _addedAt: number;
}

interface OptimisticNftsStore {
  nfts: TimestampedNft[];
  addNfts: (nfts: NftWithCollection[]) => void;
  removeNft: (address: string) => void;
  clearAll: () => void;
  /** Remove entries older than TTL */
  pruneStale: () => void;
}

export const useOptimisticNfts = create<OptimisticNftsStore>((set, get) => ({
  nfts: [],

  addNfts: (nfts) => {
    const now = Date.now();
    const timestamped = nfts.map((nft) => ({ ...nft, _addedAt: now }));
    set((state) => ({
      nfts: [...timestamped, ...state.nfts],
    }));
    // Auto-prune stale entries when adding new ones
    setTimeout(() => get().pruneStale(), 0);
  },

  removeNft: (address) =>
    set((state) => ({
      nfts: state.nfts.filter((nft) => nft.address !== address),
    })),

  clearAll: () => set({ nfts: [] }),

  pruneStale: () => {
    const now = Date.now();
    set((state) => ({
      nfts: state.nfts.filter((nft) => now - nft._addedAt < OPTIMISTIC_NFT_TTL_MS),
    }));
  },
}));
